const ArchiveMusicVideosStatic = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/fFDR1wDZPXI" title="6FEET" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            6FEET
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/_K4EdPrYcGE" title="6FEET" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Kawaii Ry & Meauxminy</strong><br/>
            Sometimes (I Know)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/UARzWic5SnY" title="u$ v3" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            u$ v3
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/QBVe2zzlhRc" title="sixtyminutes" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            sixtyminutes
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/2-770OlCAYc" title="+++rice" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            +++rice (prod. bygadriel)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/lT7F5eKwxlU" title="portland" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            portland
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Bs84gP1d888" title="Katy" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>ANJU Online!</strong><br/>
            Katy
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/I0-9h_qYDhg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            Lugosi @ CRACKFEST VI (Full Set)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/Oa17vu2-w2E" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Hellscape Radio Vol. 6</strong><br/>
            Hellscape Digital @ CRACKFEST VI (Full Set)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/cSAXCagiLRg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            paranoid
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/ioJ2ZLxPN7U" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Kawaii Ry</strong><br/>
            I'm Serious (LEGO Island AMV) [480p]
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/EgCdIxRRYdI" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            PHOTO (prod. chris6lair & Rio Leyva)
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/21VuClIGW4o" title="Hellscape Radio Vol. 5" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio Vol. 5</strong><br/>
            Kawaii Ry @ CRACKFEST V (Full Set)
            </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/viEzTBEkDMw" title="SWAG SUPPLIER" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>QADRI</strong><br/>
            IDONTWANNASEEYOU (feat. rileylol)
            </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/k-7oPEbGaC8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            KEANO
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/0PDDyumLrYo" title="SWAG SUPPLIER" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>ANJU Online! & Kawaii Ry</strong><br/>
            SWAG SUPPLIER (feat. STARINTHESKY)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/8sln1klp718" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Morose (prod. Mista)
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/pvQjdOQjEOM" title="Lugosi - ghostsinthewalls" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Lugosi</strong><br/>
            ghostsinthewalls (prod. ANJU Online!)
            </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/b2FZYmcVDik" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Eight
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/25C4IdLIRj0" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Like This (prod. Goyxrd)
          </p>

            <div class="music-video-container">
                <iframe src="https://www.youtube.com/embed/Rg1IqE0vr7s" title="Hellscape Radio Vol. 3" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
                <strong>Josen</strong><br/>
                ZA [OFFICIAL ZAZA ANTHEM]
            </p> 

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/esF2fVJ9zdg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            LOOT
          </p>

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/jTwGVGjjnLM" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            QUOTE US
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/a5TkVrfFQP8" title="spine" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            spine (prod. jodom)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/nkQdMsfp0y8" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            AMEN
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/DtIhFQSMGVg" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            ZERO
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/ka715cKjppo" title="spine" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>panda slugger & Kawaii Ry</strong><br/>
            Whole World Froze (prod. panda slugger)
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/agFi-Bglf60" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            CHELSEY
          </p>

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/7YjcSy1XSxA" title="how u doing?" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            how u doing? (prod. quimmine)
          </p> 

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/-F6EolbbvMs" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Blossom
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/YwfcLWMmelo" title="CONDITIONED ASSOCIATIONS" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            CONDITIONED ASSOCIATIONS
          </p> 

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kXeKwQsEtg4" title="Hellscape Radio Vol. 3" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio, Vol. 3</strong><br/>
            (Hosted by ANJU Online!)
            </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/3sdp4H8AweY" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>I Was Broke Last Weekend (Now I'm Up)</strong>
          </p>  

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kErw7AAVk0k" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Cruel Summer
          </p>   

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/hmxTwaOksgI" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Shawty, Pt. 2</strong>
          </p>    

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/igBUEgE6bQA" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            lost freestyle (prod. elxnce)
          </p>   

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/BtDMZBQVC5Y" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Shawty
          </p> 

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/I4mOPjK6e1o" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            PRAY 4 LUI (prod. Lil Dujour)
          </p>  

        </div>
      </>
    );
  };
  export default ArchiveMusicVideosStatic;